export const SB_PLACEMENT_ROW_NAMES = {
  TOP_OF_SEARCH: "Top of Search",
  REST_OF_SEARCH: "Rest of Search",
  DETAIL_PAGE: "Detail Page",
  HOME: "Home",
  AUDIENCE: "Audience",
} as const

// Amazon SB v4 bidAdjustmentsByPlacement enum matched/written by each placement row.
// Each row owns exactly one Amazon placement (no more fan-out of one % to three enums).
export const SB_PLACEMENT_ENUM_MATCHERS: Record<string, string[]> = {
  [SB_PLACEMENT_ROW_NAMES.TOP_OF_SEARCH]: ["TOP"],
  [SB_PLACEMENT_ROW_NAMES.REST_OF_SEARCH]: ["OTHER", "REST"],
  [SB_PLACEMENT_ROW_NAMES.DETAIL_PAGE]: ["DETAIL", "PRODUCT"],
  [SB_PLACEMENT_ROW_NAMES.HOME]: ["HOME"],
}

export const SB_DEFAULT_PLACEMENT_ENUMS: Record<string, string> = {
  [SB_PLACEMENT_ROW_NAMES.TOP_OF_SEARCH]: "TOP_OF_SEARCH",
  [SB_PLACEMENT_ROW_NAMES.REST_OF_SEARCH]: "OTHER",
  [SB_PLACEMENT_ROW_NAMES.DETAIL_PAGE]: "DETAIL_PAGE",
  [SB_PLACEMENT_ROW_NAMES.HOME]: "HOME",
}

export const SB_PLACEMENT_MODIFIER_LIMITS = {
  TOP_OF_SEARCH_MIN: 0,
  OTHER_PLACEMENT_MIN: -99,
  AUDIENCE_MIN: 0,
  MAX: 900,
} as const

// Amazon limits: Top of Search and Audience min 0, every other placement min -99.
export function sbModifierMin(placementRowName: string): number {
  return placementRowName === SB_PLACEMENT_ROW_NAMES.TOP_OF_SEARCH ||
    placementRowName === SB_PLACEMENT_ROW_NAMES.AUDIENCE
    ? SB_PLACEMENT_MODIFIER_LIMITS.TOP_OF_SEARCH_MIN
    : SB_PLACEMENT_MODIFIER_LIMITS.OTHER_PLACEMENT_MIN
}

// Order-count tiers capping the auto-SUGGESTED placement modifier.
// 11+ orders falls through to SB_PLACEMENT_MODIFIER_LIMITS.MAX.
export const SB_MODIFIER_ORDER_TIERS = [
  { maxOrders: 5, maxModifier: 10 },
  { maxOrders: 10, maxModifier: 50 },
] as const
